export default {"src":"/_next/static/media/doghouse_64.37b4e1da.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};